import { render, staticRenderFns } from "./billing-faqs.vue?vue&type=template&id=6621d0b9&"
import script from "./billing-faqs.vue?vue&type=script&lang=js&"
export * from "./billing-faqs.vue?vue&type=script&lang=js&"
import style0 from "./billing-faqs.vue?vue&type=style&index=0&id=6621d0b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports